import {
  ApplicationConfig,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';
import {
  provideTranslateLoader,
  provideTranslateService,
  type TranslateLoader,
} from '@ngx-translate/core';
import { of } from 'rxjs';

import { qrTokenInterceptor } from './core/qr-token.interceptor';
import { QrTokenService } from './core/qr-token.service';
import { DEFAULT_LANG, LanguageService } from './core/language.service';
import ru from './i18n/ru.json';
import uz from './i18n/uz.json';

registerLocaleData(localeRu);

/** Dictionaries are bundled: no dictionary RTT before first paint, and a switch can never fail. */
class StaticTranslateLoader implements TranslateLoader {
  getTranslation(lang: string) {
    return of(lang === 'ru' ? ru : uz);
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([qrTokenInterceptor])),
    provideTranslateService({
      fallbackLang: DEFAULT_LANG,
      // A factory, not the bare class: ngx-translate tells classes apart by /^class\s/, and minified
      // output (`var Ht=class{…}`) fails that test, so prod would call the class without `new`.
      loader: provideTranslateLoader(() => new StaticTranslateLoader()),
    }),
    provideAppInitializer(() => {
      // Guard non-browser contexts (tests/SSR) where window is absent.
      if (typeof window === 'undefined') return;
      inject(QrTokenService).initFromUrl();
    }),
    // Blocks the first render until the active dictionary is in — no flash of raw keys.
    provideAppInitializer(() => inject(LanguageService).init()),
    { provide: LOCALE_ID, useValue: 'ru-RU' },
  ],
};
